<kgrid *ngIf="PeopleInfoRelateds && PeopleInfoRelateds.length>0"
  #grid
  [apiName]="apiName"
  [areaName]="areaName"
  [label]="label"
  (onRowSelected)="onRowSelected($event)"
  (onCreate)="addHandler($event)"
  (onEdit)="editHandler($event)"
  (onDelete)="removeHandler($event)"
  [noToolBar]="true"
  [groupable]="false"
  [name]="apiName"
  dataKey="'UId'"
  [columns]="PeopleInfoRelateds"
  gridHeight="30"
  [paging]="false"
  [dataList]="model.PeopleInfoRelateds"
  reportName="PeopleInfoRelateds"
  pathPreFix="GNR">
</kgrid>